import { render, staticRenderFns } from "./LayoutTabs.vue?vue&type=template&id=2f0d4d98&scoped=true"
import script from "./LayoutTabs.vue?vue&type=script&lang=js"
export * from "./LayoutTabs.vue?vue&type=script&lang=js"
import style0 from "./LayoutTabs.vue?vue&type=style&index=0&id=2f0d4d98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0d4d98",
  null
  
)

export default component.exports